var exports = {
  "e": "xfd349460--9728e3--builders-list",
  "G": "xfd349460--9728e3--tooltip-content",
};

module.exports = exports;
